/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import { DomainActions } from 'app/redux/actions.js';

function mapStateToProps(state) {
    return({
        domains: state.domains
    });
}

function mapDispatchToProps(dispatch) {
    return {
        getDomains: () => {
            dispatch(DomainActions.fetchDomains());
        },
        getDomain: (id) => {
            dispatch(DomainActions.fetchDomain(id));
        },
        updateDomain: (domain) => {
            dispatch(DomainActions.updateDomain(domain));
        },
        deleteDomain: (id) => {
            dispatch(DomainActions.deleteDomain(id));
        },
        createDomain: (domain) => {
            dispatch(DomainActions.createDomain(domain));
        },
        setDefaultDomain: (id) => {
            dispatch(DomainActions.setDefaultDomain(id));
        },
        applyDomain: (id, type) => {
            dispatch(DomainActions.applyDomain(id, type));
        }
	};
}

export default function DomainProvider(Component) {

    class DomainProvider extends React.Component {
        constructor(props) {
            super(props);

            this.findDomain = this.findDomain.bind(this);

        }

        findDomain(id) {
            let domain = null;

            for (let i = 0; i < this.props.domains.length; ++i) {
                if (parseInt(this.props.domains[i].id, 10) === parseInt(id, 10)) {
                    domain = this.props.domains[i];
                    break;
                }
            }

            return domain;

        }

        render() {
            return (
                <Component
                    findDomain={this.findDomain}
                    {...this.props}/>
            );
        }
    }

    DomainProvider.displayName = "DisplayProvider";

    return connect(mapStateToProps, mapDispatchToProps)(DomainProvider);
};
